import TransactionLimit from "../components/transactionLimits";
import Nav from "../components/Nav/nav";
import Whatsapp from "../Whatsapp/whatsapp";

const Transactions = () => {
  return (
    <div>
      <Nav />
      <TransactionLimit />
      <Whatsapp/>
    </div>
  );
};

export default Transactions;
